export default __webpack_public_path__ + "static/media/moneyhash_wallet.28072e10.svg";